import React from "react";
import {
  Avatar,
  AvatarGroup,
  Box,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Typography,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";

const BatchWorkspaceSidebar = ({ batchData }) => {
  const { batch, course_template, topics, students } = batchData || {};

  // Calculate overall progress
  const totalCompleted = topics?.reduce((acc, t) => acc + t.completed_count, 0) || 0;
  const totalPossible = topics?.reduce((acc, t) => acc + t.total_students, 0) || 0;
  const overallProgress = totalPossible > 0 ? Math.round((totalCompleted / totalPossible) * 100) : 0;

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Chip
          label="Cohort"
          size="small"
          sx={{
            backgroundColor: "#EBF5FF",
            color: "#0172A6",
            fontSize: "11px",
            fontFamily: "Be Vietnam Pro",
          }}
        />
      </Box>

      <Typography
        sx={{
          color: "#202124",
          fontSize: "24px",
          fontWeight: 500,
          mb: 1,
          fontFamily: "Be Vietnam Pro",
        }}
      >
        {batch?.name || batch?.code}
      </Typography>

      <Typography
        sx={{
          color: "#6b7280",
          fontSize: "14px",
          mb: 2,
          fontFamily: "Be Vietnam Pro",
        }}
      >
        {course_template?.name}
      </Typography>

      <Typography
        sx={{
          color: "#6b7280",
          fontSize: "12px",
          mb: 1,
          fontFamily: "Be Vietnam Pro",
        }}
      >
        {course_template?.description}
      </Typography>

      <Box display="flex" mt={4} justifyContent="space-between">
        <Typography
          sx={{
            fontSize: "10px",
            color: "#868686",
            fontFamily: "Be Vietnam Pro",
          }}
        >
          {overallProgress}% avg completed
        </Typography>
        <Typography
          sx={{
            fontSize: "10px",
            color: "#868686",
            fontFamily: "Be Vietnam Pro",
          }}
        >
          {topics?.length || 0} Modules
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <LinearProgress
          variant="determinate"
          value={overallProgress}
          sx={{
            flex: 1,
            borderRadius: "5px",
            width: "100%",
            height: "8px",
            mt: 1,
          }}
        />
      </Box>

      <Card sx={{ mt: 4 }}>
        <CardContent sx={{ padding: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "8px",
                backgroundColor: "#EBF5FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <GroupIcon sx={{ color: "#0172A6", fontSize: 24 }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  color: "#202124",
                  fontSize: "16px",
                  fontWeight: 500,
                  fontFamily: "Be Vietnam Pro",
                }}
              >
                {batch?.member_count} Students
              </Typography>
              <Typography
                sx={{
                  color: "#6b7280",
                  fontSize: "12px",
                  fontFamily: "Be Vietnam Pro",
                }}
              >
                Enrolled in this batch
              </Typography>
            </Box>
          </Box>

          <AvatarGroup max={6} sx={{ justifyContent: "flex-start" }}>
            {students?.map((student, idx) => (
              <Avatar
                key={idx}
                src={student.avatar}
                sx={{ width: 32, height: 32, fontSize: "12px" }}
              >
                {student.first_name?.charAt(0)?.toUpperCase()}
              </Avatar>
            ))}
          </AvatarGroup>

          <Box sx={{ mt: 2 }}>
            {students?.map((student, idx) => (
              <Typography
                key={idx}
                sx={{
                  fontSize: "12px",
                  color: "#6b7280",
                  fontFamily: "Be Vietnam Pro",
                }}
              >
                {student.first_name} {student.last_name}
              </Typography>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BatchWorkspaceSidebar;
